<script>
  import ImageLoader from "svelte-lazy-image-loader";
  import projects from "../../constants/projects";
  import { onMount, onDestroy } from "svelte";
  import { fade } from "svelte/transition";
  import { createEventDispatcher } from "svelte";

  // export let id;
  export let project;

  let modalEl;

  const dispatch = createEventDispatcher();

  $: currentScreenshot = project.screenshots[0];

  $: console.log(project.screenshots[0]);

  // $: console.log("project", project);

  function setCurrentScreenshot(val) {
    currentScreenshot = val;
  }

  onMount(() => {
    document.body.appendChild(modalEl);
    document.body.classList.add("modal-is-open");

    return () => {
      document.body.classList.remove("modal-is-open");
    };
  });
</script>

<style>
  section {
    position: fixed;
    width: 100%;
    top: 0;
    bottom: 0;
    background-color: var(--color-theme-5);
    padding: 3rem;
    overflow: auto;
  }
  .image-container {
    max-width: 120rem;
    margin: 0 auto 2rem;
  }
  img {
    border: 1px solid #fff;
  }
  .close-btn {
    position: absolute;
    top: 2rem;
    right: 2rem;
    color: white;
  }
  .links-list-horz {
    display: flex;
    justify-content: center;
    padding: 0;
    list-style: none;
  }
  .links-list-horz li {
    margin: 0 1rem;
  }
</style>

<section bind:this={modalEl} in:fade={{ duration: 200 }}>
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
        <a
          href="#!"
          on:click|preventDefault={() => {
            dispatch('close');
          }}
          class="close-btn">
          close
        </a>
        <h1>{project.title}</h1>
        <div class="image-container">
          <img
            src={`/images/projects/details/${project.id}/${currentScreenshot}`}
            alt="" />
        </div>
        <ul class="links-list-horz">
          {#each project.screenshots as screenshot, index}
            <li>
              <a
                href="#!"
                on:click|preventDefault={() => setCurrentScreenshot(screenshot)}>
                Screen {index + 1}
              </a>
            </li>
          {/each}
        </ul>
      </div>
    </div>
  </div>
</section>
